// audio files
import dutchy from '../_audio/Flying-Dutchman.mp3';
import corp from '../_audio/Corp Throwaway Final (Finally) - 28Dec25.mp3';
import wicb from '../_audio/When I Come Back (Master MP3).mp3'
import fringe from '../_audio/On the Fringe Demo.mp3';

// audio thumbnails
import dutchyTN from '../_thumbnails/Dutchman_Cropped.webp';
import corpTN from '../_thumbnails/Corp.png';
import wicbTN from '../_thumbnails/Matt hehe.webp';
import fringeTN from '../_thumbnails/Romir dope pt 2.webp';
// import corpTN from '../_thumbnails/Aiden Flow.webp';
// import slowcrow from '../_thumbnails/slowcrow.png'


export const tracks = [
    {
        id: 0,
        title: 'Flying Dutchman',
        src: dutchy,
        thumbnail: dutchyTN,
    },
    {
        id: 1,
        title: 'Corporate Throwaway',
        src: corp,
        thumbnail: corpTN,
    },
    {
        id: 2,
        title: 'When I Come Back',
        src: wicb,
        thumbnail: wicbTN,
    },
    {
        id: 3,
        title: 'On The Fringe (Demo)',
        src: fringe,
        thumbnail: fringeTN,
    },
];